module.exports = __webpack_public_path__ + "img/gyuszigumi1.fd60aae3.jpg";